<div class="p-6 px-0 w-full h-full flex flex-col">
  <div class="pt-0 pb-3 flex flex-col md:flex-row md:items-center md:justify-start gap-4">
    <div class="shrink-0">
      <ng-content select="[table-title]"></ng-content>
    </div>
    <div class="flex items-center gap-4">
      <ng-container *ngTemplateOutlet="paginationNav; context: { label: 'Pagination (top)' }"></ng-container>
      <prism-select-page-size (pageSize)="handlePageSizeChange($event)">
      </prism-select-page-size>
    </div>
  </div>
  <div class="flex-grow relative overflow-x-auto">
    @if (tableData && tableData.length > 0) {
      <table class="mt-4 w-full table-auto text-left" aria-label="Data Table">
        <thead>
          <tr>
            @for (col of columns; track col) {
              <th scope="col" class="px-2 sm:px-4 whitespace-nowrap"
                [attr.aria-sort]="sortColumn === col ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'">
                <button type="button"
                  class="text-sm font-semibold text-dark-purple flex items-center justify-start gap-2 w-full"
                  (click)="handleSortByColumn(col)"
                  [attr.aria-label]="'Sort by ' + (colHeaders[col] ?? col)">
                  {{ colHeaders[col] ?? col }}
                  @if (sortColumn === col) {
                    <i class="uil" aria-hidden="true" [ngClass]="{
                        'uil-angle-up': sortDirection === 'asc',
                        'uil-angle-down': sortDirection === 'desc'
                      }"></i>
                  }
                </button>
              </th>
            }
            @if (isDelete || isEdit) {
              <th scope="col" class="px-2 sm:px-4 whitespace-nowrap">
                <span class="sr-only">Actions</span>
              </th>
            }
          </tr>
        </thead>
        <tbody>
          @for (data of tableData; track $index) {
            <tr class="bg-light-purple border-y-8 border-white sm:m-5">
              @for (col of columns; track col) {
                <td class="py-2 px-2 sm:px-4"
                  [ngClass]="{
                    'rounded-l-2xl': $index === 0,
                    'whitespace-nowrap': col === 'status' || col === 'completedOn' || col === 'fullName',
                    'max-w-xs md:max-w-sm lg:max-w-md break-words': col === 'districtName'
                  }">
                  {{ data[col] }}
                </td>
              }
              <td class="rounded-r-2xl">
                @for (item of actions; track $index) {
                  @if (item.isActive) {
                    <button class="pl-2 text-2xl" [attr.aria-label]="item.label" (click)="item.handler(data, item.type)">
                      <i [class]="item.icon" aria-hidden="true"></i>
                    </button>
                  }
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    } @else if (tableData && tableData.length < 1) {
      <div class="mt-4 w-full text-center py-12 text-gray-500" role="status" aria-live="polite">
        No data available
      </div>
    }
  </div>
  <div class="flex justify-start pt-3 lg:pt-6">
    <div class="relative inline-flex">
      <div class="flex flex-wrap items-center justify-start">
        <ng-container *ngTemplateOutlet="paginationNav; context: { label: 'Pagination (bottom)' }"></ng-container>
      </div>
    </div>
  </div>
</div>

<ng-template #paginationNav let-label="label">
  @if (totalPages > 0) {
    <nav class="flex items-center gap-1" [attr.aria-label]="label">
      <button type="button"
        class="px-2 py-1 text-dark-purple disabled:opacity-50 disabled:cursor-not-allowed"
        [disabled]="pageIndex <= 1"
        (click)="handlePageIndexChange(pageIndex - 1)"
        aria-label="Go to previous page">
        Previous
      </button>
      @for (page of pageNumbers; track $index) {
        @if (page === '...') {
          <span class="px-2 py-1 text-gray-500" aria-hidden="true">…</span>
        } @else {
          <button type="button"
            class="px-2 py-1 min-w-[2rem] text-dark-purple"
            [class.font-bold]="page === pageIndex"
            [class.underline]="page === pageIndex"
            [attr.aria-current]="page === pageIndex ? 'page' : null"
            [attr.aria-label]="'Go to page ' + page"
            (click)="selectPage(page)">
            {{ page }}
          </button>
        }
      }
      <button type="button"
        class="px-2 py-1 text-dark-purple disabled:opacity-50 disabled:cursor-not-allowed"
        [disabled]="pageIndex >= totalPages"
        (click)="handlePageIndexChange(pageIndex + 1)"
        aria-label="Go to next page">
        Next
      </button>
    </nav>
  }
</ng-template>
